import { connect } from 'react-redux';

import {
  projectExport,
  projectGet,
  projectShare,
} from 'actions';

import View from './';

const mapStateToProps = (state) => {
  return {
    intl: state.intl,
    project: state.projects.single,
    share: state.projects.share,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    projectExport(...payload) {
      return dispatch(projectExport(...payload));
    },
    projectGet(...payload) {
      return dispatch(projectGet(...payload));
    },
    projectShare(...payload) {
      return dispatch(projectShare(...payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./js/views/systems/detail/share/container.js